<template>
    <div id="open-assignment" class="container p-5">
        <h1>Offerte Aanvraag</h1>
        <div class="alert alert-info mb-5" role="alert">
            <strong>Let op!</strong> Na het insturen van een offerteaanvraag, zal iemand van Azurity <strong>binnen 24 uur contact</strong> met u opnemen.
        </div>
        <div class="form-row">
            <div class="col-md-12">
                <h2>Contactgegevens</h2>
                <div class="form-group row">
                    <label class="col-md-2 col-form-label">Organisatie</label>
                    <div class="col-md-10">
                        <input name="company" :class="['form-control', ($v.assignment.company.$dirty) ? ($v.assignment.company.$error) ?'is-invalid' : 'is-valid' : '']" type="text" placeholder="Bedrijfsnaam" v-model="assignment.company" :disabled="isLoading" />
                        <div class="invalid-feedback">
                            Bedrijfsnaam is verplicht.
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-2 col-form-label">Naam</label>
                    <div class="col-md-5">
                        <input name="firstName" :class="['form-control', ($v.assignment.firstName.$dirty) ? ($v.assignment.firstName.$error) ?'is-invalid' : 'is-valid' : '']" type="text" placeholder="Voornaam" v-model="assignment.firstName" :disabled="isLoading" />
                        <div class="invalid-feedback">
                            Voornaam is verplicht.
                        </div>
                    </div>
                    <div class="col-md-5">
                        <input name="lastName" :class="['form-control', ($v.assignment.lastName.$dirty) ? ($v.assignment.lastName.$error) ?'is-invalid' : 'is-valid' : '']" type="text" placeholder="Achternaam" v-model="assignment.lastName" :disabled="isLoading" />
                        <div class="invalid-feedback">
                            Achternaam is verplicht.
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-2 col-form-label">Telefoonnummer</label>
                    <div class="col-md-10">
                        <input name="phone" :class="['form-control', ($v.assignment.phone.$dirty) ? ($v.assignment.phone.$error) ?'is-invalid' : 'is-valid' : '']" type="tel" placeholder="Vaste lijn" v-model="assignment.phone" :disabled="isLoading" />
                        <div class="invalid-feedback">
                            Telefoonnummer of mobielenummer is verplicht.
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-2 col-form-label">Mobielnummer</label>
                    <div class="col-md-10">
                        <input name="mobile" :class="['form-control', ($v.assignment.mobile.$dirty) ? ($v.assignment.mobile.$error) ?'is-invalid' : 'is-valid' : '']" type="tel" placeholder="06-" v-model="assignment.mobile" :disabled="isLoading" />
                        <div class="invalid-feedback">
                            Telefoonnummer of mobielenummer is verplicht.
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-2 col-form-label">Email</label>
                    <div class="col-md-10">
                        <input name="email" :class="['form-control', ($v.assignment.email.$dirty) ? ($v.assignment.mobile.$error) ?'is-invalid' : 'is-valid' : '']" type="email" placeholder="Emailadres" v-model="assignment.email" :disabled="isLoading" />
                        <div class="invalid-feedback">
                            Email is verplicht.
                        </div>
                    </div>
                </div>
                <hr  class="mt-5 mb-5">
            </div>
            <div class="col-md-12">
                <h2>Opdrachtgegevens</h2>
            </div>
            <div class="col-md-6 mb-3">
                <div class="form-group">
                    <label class="form-label">Titel</label>
                    <input name="title" :class="['form-control', ($v.assignment.title.$dirty) ? ($v.assignment.title.$error) ?'is-invalid' : 'is-valid' : '']" placeholder="Titel van de opdracht" v-model="assignment.title"  :disabled="isLoading"/>
                    <div class="invalid-feedback">
                        Titel van de opdracht is verplicht.
                    </div>
                </div>
                <div class="form-group">
                    <label class="form-label">Opdrachtomschrijving</label>
                    <textarea name="description" :class="['form-control', ($v.assignment.description.$dirty) ? ($v.assignment.description.$error) ?'is-invalid' : 'is-valid' : '']" rows="15" placeholder="Omschrijf hier de opdracht, werkzaamheden, etc..."  v-model="assignment.description" :disabled="isLoading"></textarea>
                    <div class="invalid-feedback">
                        Opdrachtomschrijving is verplicht.
                    </div>
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <div class="form-group">
                    <label class="form-label">Aantal professionals</label>
                    <input name="quantity" :class="['form-control', ($v.assignment.professionalsQty.$dirty) ? ($v.assignment.professionalsQty.$error) ?'is-invalid' : 'is-valid' : '']" type="number" placeholder="1" v-model="assignment.professionalsQty" :disabled="isLoading" />
                    <div class="invalid-feedback">
                        Minimaal 1 beveiliger.
                    </div>
                </div>
                <div class="form-group">
                    <label class="form-label">Plaats van uitvoering</label>
                    <v-select name="city" label="name" :filterable="false" :options="$store.getters.cities" @search="onSearchCity" v-model="assignment.city" :class="['form-control', ($v.assignment.city.$dirty) ? ($v.assignment.city.$error) ?'is-invalid' : 'is-valid' : '']" placeholder="Plaats" id="city">
                        <template slot="no-options">
                            Zoek een plaats...
                        </template>
                        <template slot="option" slot-scope="option" class="m-0 p-0">
                            <div class="d-center m-0 p-0" >
                                {{ option.name }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.name }}
                            </div>
                        </template>
                    </v-select>
                    <div class="invalid-feedback">
                        Plaatsnaam is verplicht.
                    </div>
                </div>
                <div class="form-group">
                    <label class="form-label">Datum van uitvoering</label>
                    <input name="date" :class="['form-control', ($v.assignment.assignmentDate.$dirty) ? ($v.assignment.assignmentDate.$error) ?'is-invalid' : 'is-valid' : '']" type="date" v-model="assignment.assignmentDate" :disabled="isLoading" />
                    <div class="invalid-feedback">
                        Datum van uitvoering is verplicht.
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="form-label" for="startTime">Aanvang (verwacht)</label>
                            <div class="control">
                                <input name="time" :class="['form-control', ($v.assignment.startTime.$dirty) ? ($v.assignment.startTime.$error) ?'is-invalid' : 'is-valid' : '']" type="time" v-model="assignment.startTime" id="startTime" :disabled="isLoading" />
                                <div class="invalid-feedback">
                                    Verwachte starttijd is verplicht.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="form-label" for="endTime">Duur (in uren)</label>
                            <div class="control">
                                <input name="hours" :class="['form-control', ($v.assignment.hours.$dirty) ? ($v.assignment.hours.$error) ?'is-invalid' : 'is-valid' : '']" type="number" v-model="assignment.hours" id="hours" :disabled="isLoading" />
                                <div class="invalid-feedback">
                                    Verwachte aantal uren is verplicht.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <select :class="['form-control mb-3', ($v.assignment.skills.$dirty) ? ($v.assignment.skills.$error) ?'is-invalid' : 'is-valid' : '']" v-model="selectedAssignmentSkill" @change="addSkill" :disabled="isLoading">
                        <option value="-1">Selecteer vaardigheden...</option>
                        <optgroup>
                            <option :value="s" v-for="s in $store.getters.skills" :key="s.id" >{{s.description}}</option>
                        </optgroup>
                    </select>
                    <div class="invalid-feedback">
                        U dient minimaal 1 vaardigheid op te geven.
                    </div>
                    <h5 v-for="p in assignment.skills" :key="p.skillId" @click="removeSkill(p)" class="badge-horizontal mr-2">
                        <span class="badge badge-pill badge-secondary clickable">{{p.skill.description}}</span>
                    </h5>
                </div>
                <div class="form-group  mb-5">
                    <div class="custom-control custom-checkbox">
                        <input name="generalConditions" type="checkbox" id="generalConditions" v-model="assignment.generalConditions" :class="['custom-control-input', ($v.assignment.generalConditions.$dirty) ? ($v.assignment.generalConditions.$error) ?'is-invalid' : 'is-valid' : '']" required>
                        <label class="custom-control-label" for="generalConditions">Ik ga akkoord met de <router-link tag="a" target="_blank" to="/security/voorwaarden">voorwaarden</router-link> van Azurtiy.</label>
                    </div>
                </div>
                <div class="form-group text-right">
                    <loader width="2rem" v-if="isLoading"></loader>
                    <button class="btn btn-outline-azure btn-half btn-lg mb-3" aria-label="Direct opdracht insturen" @click="saveAssignment" :disabled="isLoading" v-else>
                        <span>Offerteaanvraag <br> versturen</span>
                        <div class="btn-icon">
                            <span>&rarr;</span>
                        </div>
                    </button>
                </div>
            </div>
            <div class="col-md-12">
                <transition name="fade">
                    <div class="alert alert-success mb-5" role="alert" v-if="isSuccess">
                        <strong>Bedankt!</strong> Uw offerteaanvraag is succesvol verstuurd naar Azurity.
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import { validationMixin } from 'vuelidate';
import { required, requiredIf, minLength, maxLength, helpers, integer, minValue, email } from 'vuelidate/lib/validators';
import { assignment } from '@/models/models.js';
import Loader from '@/components/Loader';

const mobile = helpers.regex('mobile', /^(((\\+31|0|0031)6){1}[1-9]{1}[0-9]{7}|((\\+31|0|0031)6)[-]{1}[1-9]{1}[0-9]{7})$/);
const landline = helpers.regex('landline', /^(((0)[1-9]{2}[0-9][-]?[1-9][0-9]{5})|((\\+31|0|0031)[1-9][0-9][-]?[1-9][0-9]{6}))$/);

const arrayNotEmpty = (value) => value.length > 0;
const greaterThanToday = (value, vm) => new Date(value) > new Date();
const mustBeTrue = (value) => {
    if(value != null)
    {
        return value
    }
    return true;
};

export default {
    mixins: [validationMixin],
    components: {
        Loader,
        vSelect
    },
    data() {
        return {
            isLoading: false,
            isSuccess: false,
            selectedAssignmentSkill: -1,
            skillsList: [],
            generalConditions: false,
            assignment: 
            {
                company: '',
                firstName: '',
                lastName: '',
                phone: '',
                mobile: '',
                email: '',
                title: '',
                description: '',
                professionalsQty: 1,
                city: '',
                assignmentDate: null,
                startTime: null,
                hours: 0,
                skills: [],
                generalConditions: false
            },
        }
    },
    validations: {
        assignment: {
            company: {

            },
            firstName: {
                required
            },
            lastName: {
                required
            },
            phone: {
                required: requiredIf((vm) => !vm.mobile),
                landline
            },
            mobile: {
                required: requiredIf((vm) => !vm.phone),
                mobile
            },
            email: {
                required,
                email
            },
            title: {
                required,
                minLength: minLength(2),
                maxLength: maxLength(50),
            },
            description: {
                required,
                minLength: minLength(2),
                maxLength: maxLength(2000),
            },
            professionalsQty: {
                required,
                integer,
                minValue: minValue(1)
            },
            city: {
                required
            },
            assignmentDate: {
                required,
                greaterThanToday
            },
            startTime: {
                required
            },
            hours: {
                required,
                integer,
                minValue: minValue(1)
            },
            skills: {
                required,
                arrayNotEmpty
            },
            generalConditions: {
                required,
                mustBeTrue
            },
        }
    },
    mounted() {
        this.$store.dispatch("GET_SKILLS");
    },
    methods: {
        onSearchCity(search, loading) {
            this.$store.dispatch('GET_CITIES', { search, loading });
        }, 
        addSkill() {
            const assignmentSkill = { 
                id: 0,
                skillId: this.selectedAssignmentSkill.id,
                skill: this.selectedAssignmentSkill
            };
            if(!this.assignment.skills.some((c) => { return c.skillId == assignmentSkill.skillId }) && !this.isLoading)
            {
                this.assignment.skills.push(assignmentSkill);
            }
            this.selectedAssignmentSkill = -1;
        },
        removeSkill(skill) {
            if(this.assignment.skills.indexOf(skill) >= 0 && !this.isLoading)
                this.assignment.skills.splice(this.assignment.skills.indexOf(skill), 1);
        },
        saveAssignment() {
            this.$v.$touch();
            if(!this.$v.$invalid)
            {
                this.isLoading = true;
                this.$http.post('api/Assignments/Open', this.assignment).then(() => {
                    this.isSuccess = true;
                    this.isLoading = false;
                }).catch(() => {
                    this.isLoading = false;
                    alert("Oops, er is iets fout gegaan, probeer nogmaals.")
                });
            }
        }
    },
}
</script>

<style scoped>
.form-label {
    font-weight: bold;
}
.badge-horizontal {
    display: inline-block;
}
</style>